import { createMaxLengthRule } from "./general";

export const ORGANIZATION_CONSTANTS = {
    ORGANIZATION: 'Organization',
    CREATE_BUSINESS_UNIT: 'Create Business Unit',
    ENABLE_SUBSCRIPTION: 'Enable Subscription',
    VENDOR_SELECT_WARNING: "Please select a vendor to show it's {{entity}}.",
    BUSINESS_UNIT_NAME: 'Business Unit Name',
    BRAND: 'Brand',
    BRAND_CODE: 'Brand Code',
    ENTER_UNIT_NAME: 'Enter Business Unit Name',
    SELECT_BRAND: 'Select Brand',
    ADD_BRAND: 'Add Brand',
    BRAND_CODES: 'Brand Code',
    BRAND_LOGO: 'Brand Logo',
    BUSINESS_UNIT_CREATED: 'Business unit created successfully',
    BUSINESS_UNIT_UPDATED: 'Business unit updated successfully',
    BUSINESS_UNIT_DELETED: 'Business unit(s) deleted successfully',
    BUSINESS_UNIT_DEACTIVATED: 'Business unit(s) deactivated successfully',
    BUSINESS_UNIT_BLOCKED: 'Some business units could not be deactivated',
    BRAND_PRODUCTS_AUTO_ATTACH_NOTE: 'Products belong to a brand, not to a business unit. Any product that already exists on the selected brand will be attached to this business unit automatically.',
    BUSINESS_UNIT: 'Business Unit',
    BUSINESS_UNITS: 'Business Units',
    DELETE_UNIT_TEXT_1: 'Would you like to remove',
    DELETE_UNIT_TEXT_2: 'All brand and product mapping to this business unit will be removed as well.',
    NUMBER_OF_USERS: 'Number of Users',
    SELECT_BUSINESS_UNIT: 'Select business unit',
    PLEASE_CREATE_BUSINESS_UNIT: 'Please create business unit.',
    // Admins Tab Constants
    ADMINS: 'Admin',
    INVITE_ADMIN: 'Invite Admin',
    VENDORS: 'Vendor',
    ADMIN_REMOVED: 'Admin(s) removed successfully',
    DELETE_ADMIN_CONFIRMATION: 'Are you sure you want to remove this admin(s)?',
    ADMINS_TAB_INDEX: 2,
}

export const BUSINESS_UNIT_FORM_FIELDS = {
    NAME: 'name',
    BRAND: 'brandId',
    ENABLE_SUBSCRIPTION: 'isSubscriptionEnabled',
}

export const BUSINESS_UNIT_FORM_ERRORS = {
    BUSINESS_UNIT_NAME: 'Business unit name is required',
    MAX_CHARACTERS: 'Max {{characters}} characters allowed',
    BRAND: 'Brand is required',
}

export const UNIT_FORM_RULES: { [key: string]: any } = {
    UNIT_NAME: {
        maxLength: createMaxLengthRule(60, BUSINESS_UNIT_FORM_ERRORS.MAX_CHARACTERS),
        validate: (value: string) => {
            if (value?.trim() === '') {
                return BUSINESS_UNIT_FORM_ERRORS.BUSINESS_UNIT_NAME;
            }
            return true;
        }
    },
    BRAND: {
        // Validate atleast one brand is selected
        validate: (value: string) => {
            if (!value) {
                return BUSINESS_UNIT_FORM_ERRORS.BRAND;
            }
            return true;
        }
    }
}